import baseAPI from '@/api';
import { AxiosResponse } from 'axios';
import { QueryFunctionContext } from '@tanstack/react-query';
import { UseRollCompetitionEntriesMeQueryKeyProps } from './props';
import { RollCompetitionEntryWithPlace } from '@/models/roll-competition/entries/with-place/inde';
import { RollCompetitionEntriesMeRequestDto } from '@/services/dto/roll-competition-entries/roll-competition-entries-me-request.dto';
import { Nullable } from '@starsoft/common/interfaces';

export async function fetchRollCompetitionEntriesMeWithPlace({
  queryKey,
}: QueryFunctionContext<UseRollCompetitionEntriesMeQueryKeyProps>): Promise<
  Nullable<RollCompetitionEntryWithPlace>
> {
  const params: RollCompetitionEntriesMeRequestDto = queryKey[1];

  const response: AxiosResponse<Nullable<RollCompetitionEntryWithPlace>> =
    await baseAPI.get<Nullable<RollCompetitionEntryWithPlace>>(
      `/roll-competition-entries/me`,
      {
        params,
      },
    );

  return response.data;
}
